import { createContext, ReactNode, useEffect, useState } from 'react';

type UIContextType = {
  headerVisible: boolean;
  hasUserInteracted: boolean;
  setHeaderVisible: (visible: boolean) => void;
};

export const uiContext = createContext<UIContextType>({
  // properties
  headerVisible: true,
  hasUserInteracted: false,

  // methods
  setHeaderVisible: () => {
    console.log('setHeaderVisible not implemented');
  },
});

export const UIContextProvider = ({ children }: { children: ReactNode }) => {
  const [headerVisible, setHeaderVisible] = useState(true);
  const [hasUserInteracted, setHasUserInteracted] = useState(false);

  // Add user interaction detection directly in provider
  useEffect(() => {
    const handleUserInteraction = () => {
      setHasUserInteracted(true);
      console.log('User interaction detected');
      // Remove listeners after first interaction
      document.removeEventListener('click', handleUserInteraction);
      document.removeEventListener('touchstart', handleUserInteraction);
    };

    // Add listeners for user interaction
    document.addEventListener('click', handleUserInteraction);
    document.addEventListener('touchstart', handleUserInteraction);
    return () => {
      document.removeEventListener('click', handleUserInteraction);
      document.removeEventListener('touchstart', handleUserInteraction);
    };
  }, []);

  return (
    <uiContext.Provider
      value={{
        headerVisible,
        setHeaderVisible,
        hasUserInteracted,
      }}
    >
      {children}
    </uiContext.Provider>
  );
};
